export default __webpack_public_path__ + "static/media/down-arrow.93d3293d.svg";